<template>
  <div class="member_club--wrap">
    <div class="main-content main-content--mobile layout main-content--spaced" style="padding-top: 0px;">
      <div class="m-loyalty-program">
        <div class="m-loyalty-program__title ms-row">
          <div class="m-loyalty-program__title-logo col-xs-12 col-md-7">
            <picture>
              <source media="(min-width: 1024px)"
                srcset="../assets/imgs/bg/loyalty-program/express-flower-gel-double-tensor-7-large.png, ../assets/imgs/bg/loyalty-program/express-flower-gel-double-tensor-7-large@2x.png 2x">
              <source media="(min-width: 768px)"
                srcset="../assets/imgs/bg/loyalty-program/express-flower-gel-double-tensor-7-medium.png, ../assets/imgs/bg/loyalty-program/express-flower-gel-double-tensor-7-medium@2x.png 2x">
              <source media="(min-width: 0px)"
                srcset="../assets/imgs/bg/loyalty-program/express-flower-gel-double-tensor-7.png, ../assets/imgs/bg/loyalty-program/express-flower-gel-double-tensor-7@2x.png 2x">
              <img class=" lazyloaded"
                srcset="../assets/imgs/bg/loyalty-program/express-flower-gel-double-tensor-7-large@2x.png"
                src="../assets/imgs/bg/loyalty-program/express-flower-gel-double-tensor-7-large.png">
            </picture>
          </div>
          <div class="col-xs-12 col-md-5">
            <div class="heading-h2 m-loyalty-program__title-heading">
              <img class="my-sisley-club-logo lazyloaded" alt="我的希思黎俱乐部" title="我的希思黎俱乐部"
                src="../assets/imgs/bg/my-sisley-club/my-sisley-club-title.svg">
            </div>
            <div class="m-loyalty-program__title-desc">法国希思黎 至臻坊会员</div>
            <div class="m-loyalty-program__title-desc">会员礼遇 倍至奢宠</div>
            <!-- <div class="m-loyalty-program__title-description">
              为了感谢您的信任和对您的关心，Sisley创建了My Sisley Club，该计划可奖励您的忠诚度，并在全年为您保留特权，关注和独家待遇。
            </div> -->
          </div>
        </div>
      </div>
      <!--  -->
      <div class="m-loyalty-program">
        <div class="m-loyalty-program__subscription">
          <div class="m-loyalty-program__subscription-flower">
            <picture>
              <source media="(min-width: 1024px)"
                srcset="../assets/imgs/bg/loyalty-program/gettyimages-746114359-1024-x-1024-ok-large.png, ../assets/imgs/bg/loyalty-program/gettyimages-746114359-1024-x-1024-ok-large@2x.png 2x">
              <source media="(min-width: 768px)"
                srcset="../assets/imgs/bg/loyalty-program/gettyimages-746114359-1024-x-1024-ok-medium.png, ../assets/imgs/bg/loyalty-program/gettyimages-746114359-1024-x-1024-ok-medium@2x.png 2x">
              <source media="(min-width: 0px)"
                srcset="../assets/imgs/bg/loyalty-program/gettyimages-746114359-1024-x-1024-ok.png, ../assets/imgs/bg/loyalty-program/gettyimages-746114359-1024-x-1024-ok@2x.png 2x">
              <img class=" lazyloaded"
                srcset="../assets/imgs/bg/loyalty-program/gettyimages-746114359-1024-x-1024-ok-large@2x.png"
                src="../assets/imgs/bg/loyalty-program/gettyimages-746114359-1024-x-1024-ok-large.png">
            </picture>
          </div>
          <!-- <h2 class="m-loyalty-program__subscription-title heading-h2 text--right sm-text--center">用您的积分为您提供产品</h2> -->
          <h2 class="m-loyalty-program__subscription-title heading-h2 text--right sm-text--center"></h2>
          <div class="ms-row m-loyalty-program__subscription-visual">
            <div
              class="col-xs-12 col-sm-5 m-loyalty-program__subscription-item m-loyalty-program__subscription-item--platinum">
              <span class="m-loyalty-program__subscription-value">1 </span>
              <span class="m-loyalty-program__subscription-currency">元</span>
              <div class="m-loyalty-program__subscription-label heading-h3">消费</div>
            </div>
            <div class="col-xs-12 col-sm-2 text--center m-loyalty-program__subscription-equal-sign"><span>=</span></div>
            <div
              class="col-xs-12 col-sm-5 m-loyalty-program__subscription-item m-loyalty-program__subscription-item--gold">
              <span class="m-loyalty-program__subscription-value">1 </span>
              <span class="m-loyalty-program__subscription-currency">积分</span>
              <div class="m-loyalty-program__subscription-label heading-h3">获得会员积分</div>
            </div>
          </div>
          <hr class="m-loyalty-program__subscription-separator">
          <div class="ms-row m-loyalty-program__subscription-texts">
            <div class="col-xs-12 col-sm-6">
              <h4 class="heading-h4 m-loyalty-program__subscription-subtitle">怎样才能成为Sisley法国希思黎至臻坊的会员？</h4>
              <div class="m-loyalty-program__subscription-description">
                您只需在中国大陆地区任一官方渠道：法国希思黎品牌专柜（包括专卖店）、睿秀护发品牌独立专柜，或法国希思黎中国官方网站、法国希思黎微信小程序官方商城、法国希思黎天猫旗舰店购买任意希思黎产品或睿秀护发产品，即可成为法国希思黎至臻坊会员。
              </div>
            </div>
            <div class="col-xs-12 col-sm-6">
              <h4 class="heading-h4 m-loyalty-program__subscription-subtitle">如何累计我的会员积分？</h4>
              <div class="m-loyalty-program__subscription-description">
                初次注册后任意消费即可成为银卡会员，每消费1元可累计1积分（专卖店消费1元可累计1.5分）
                *法国希思黎专卖店：上海太古汇/上海国金/上海国贸汇广场/上海港汇/杭州万象城/南京德基/重庆IFS/重庆北城天街/重庆万象城/成都万象城/成都太古里/厦门万象城/广州天环/深圳海岸城/合肥万象城/深圳罗湖万象城/深圳万象天地。
              </div>
            </div>
          </div>
          <div class="m-loyalty-program__subscription-actions">
            <button type="button"
              class="c-button c-button--secondary m-loyalty-program__subscription-button login-popin-toggler">创建帐户</button>
            <button type="button"
              class="c-button c-button--secondary m-loyalty-program__subscription-button login-popin-toggler">登录</button>
            <a
              class="c-button c-button--secondary m-loyalty-program__subscription-button m-loyalty-program__subscription-button--for-logged-in">查看我的帐户</a>
          </div>
          <div class="m-loyalty-program__subscription-colored-boxes">
            <div class="ms-row">
              <div
                class="col-xs-4 m-loyalty-program__subscription-colored-box m-loyalty-program__subscription-colored-box--orchid">
                &nbsp;</div>
              <div
                class="col-xs-4 m-loyalty-program__subscription-colored-box m-loyalty-program__subscription-colored-box--gold">
                &nbsp;</div>
              <div
                class="col-xs-4 m-loyalty-program__subscription-colored-box m-loyalty-program__subscription-colored-box--platinum">
                &nbsp;</div>
            </div>
          </div>
        </div>
      </div>
      <!-- 轮播 -->
      <div class="c-content-carousel m-loyalty-program__slider c-carousel">
        <div class="icon__title">
          <IconTitle :config="{ title: '会员卡和权益' }" />
        </div>
        <div class="swiper__wrap">
          <swiper class="swiper-x-container" :ref="'mcSwiper' + _uid" :options="swiperOpts">
            <swiper-slide class="swiper-x-item" v-for="(item, index) in items4Level" :key="index">
              <div class="c-content-carousel__item--secondary ms-row collapsed" :data-idx="index"
                style="width: 100%; display: inline-block;">
                <div class="col-xs-12 center-xs">
                  <div :class="['c-text-image', 'c-text-image--sixth', 'm-loyalty-program__slide', item.cls]">
                    <div class="c-text-image__visual text--right">
                      <picture>
                        <source media="(min-width: 1024px)" :srcset="`${item.src}, ${item.src2x} 2x`">
                        <source media="(min-width: 768px)" :srcset="`${item.src}, ${item.src2x} 2x`">
                        <source media="(min-width: 0px)" :srcset="`${item.src}, ${item.src2x} 2x`">
                        <img class="image--full-width lazyloaded" :srcset="`${item.src2x} 2x`" :src="item.src">
                      </picture>
                      <div class="c-text-image__visual-title">{{ item.text }}</div>
                      <!-- <div class="c-text-image__tag c-text-image__tag--black">{{item.level}}</div> -->
                    </div>
                    <div class="c-text-image__content start-xs">
                      <div class="c-text-image__text">
                        <div class="c-text-image__description">{{ item.desc.main }}</div>
                        <ul class="c-text-image__list">
                          <li class="c-text-image__list-item" v-for="(innerItem, innerIdx) in item.desc.options"
                            :key="innerIdx">{{ innerItem }}</li>
                        </ul>
                        <!-- <button class="c-text-image__btn">{{item.text + '权益介绍'}}</button> -->
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </swiper-slide>
          </swiper>
          <SwiperNavigator :xSwiper="mcSwiper" :total="3" />
        </div>
      </div>
      <!-- Q&A -->
      <div class="m-loyalty-program">
        <div class="m-loyalty-program__faq-heading">
          <IconTitle :config="{ title: '会员&积分问题' }" />
        </div>
        <div class="m-loyalty-program__faq layout">
          <div v-for="(item, index) in items4QA" :key="index"
            :class="['c-toggler', activeIndex == index ? 'c-toggler--expanded' : '']" @click="toggle(index)">
            <h4 class="c-toggler__title">{{ item.q }}</h4>
            <div class="c-toggler__content" v-html="htmlify(item.a)"></div>
          </div>
        </div>
      </div>
    </div>
    <!-- 背景图 -->
    <div class="m-loyalty-program__background show-for-md">
      <picture>
        <source media="(min-width: 1366px)"
          srcset="../assets/imgs/bg/my-sisley-club/my.png, ../assets/imgs/bg/my-sisley-club/my@2x.png 2x">
        <source media="(min-width: 1024px)"
          srcset="../assets/imgs/bg/my-sisley-club/my.png, ../assets/imgs/bg/my-sisley-club/my@2x.png 2x">
        <source media="(min-width: 768px)"
          srcset="../assets/imgs/bg/my-sisley-club/my.png, ../assets/imgs/bg/my-sisley-club/my@2x.png 2x">
        <source media="(min-width: 0px)"
          srcset="../assets/imgs/bg/my-sisley-club/my.png, ../assets/imgs/bg/my-sisley-club/my@2x.png 2x">
        <img class="image--full-width lazyloaded" alt="我的希思黎俱乐部" srcset="../assets/imgs/bg/my-sisley-club/my@2x.png 2x"
          src="../assets/imgs/bg/my-sisley-club/my.png">
      </picture>
    </div>
    <!-- Dialog -->
    <Dialog :show="showLevelIndex != -1" wrapCls="level-intro" @hide="hideLevelIntro">
      <div class="level__intro--image">
        <vue-scroll :ops="vsOpts">
          <img :src="currLevelImage" />
        </vue-scroll>
      </div>
    </Dialog>
  </div>
</template>

<script>
import IconTitle from "@/components/IconTitle";
import "swiper/dist/css/swiper.css";
import { swiper, swiperSlide } from "vue-awesome-swiper";
import SwiperNavigator from '@/components/SwiperNavigator';
import 'vuescroll/dist/vuescroll.css';
import VueScroll from 'vuescroll/dist/vuescroll-native';
import Dialog from '@/components/Dialog';
// eslint-disable-next-line no-unused-vars
import utils from "@/utils";

// eslint-disable-next-line no-unused-vars
import i1 from "@/assets/imgs/level-0.jpg";
// eslint-disable-next-line no-unused-vars
import i2 from "@/assets/imgs/level-1.jpg";
// eslint-disable-next-line no-unused-vars
import i3 from "@/assets/imgs/level-2.jpg";

import orchid from "@/assets/imgs/bg/loyalty-program/BACKGROUND-ORCHIDEE-nogutter.jpg";
import orchid2x from "@/assets/imgs/bg/loyalty-program/BACKGROUND-ORCHIDEE-nogutter@2x.jpg";
import gold from "@/assets/imgs/bg/loyalty-program/BACKGROUND-GOLD-nogutter.jpg";
import gold2x from "@/assets/imgs/bg/loyalty-program/BACKGROUND-GOLD-nogutter@2x.jpg";
import platinum from "@/assets/imgs/bg/loyalty-program/BACKGROUND-PLATINUM-nogutter.jpg";
import platinum2x from "@/assets/imgs/bg/loyalty-program/BACKGROUND-PLATINUM-nogutter@2x.jpg";

export default {
  name: "MemberClub",
  components: { IconTitle, swiper, swiperSlide, SwiperNavigator, VueScroll, Dialog },
  data() {
    return {
      mcSwiper: {},
      swiperOpts: {
        loop: true,
        loopedSlides: 5,
        speed: 1000,
        slidesPerView: 2,
        // spaceBetween: 16,
        navigation: {
          prevEl: `.mcSwiper${this._uid} .swiper-button-prev`,
          nextEl: `.mcSwiper${this._uid} .swiper-button-next`
        },
        breakpoints: {
          1024: {
            slidesPerView: 1,
            // centeredSlides: this.config.nodes.length > 3 ? true : false,
            // centeredSlidesBounds: this.config.nodes.length > 3 ? true : false,
            spaceBetween: 0
          }
        },
        // on: {
        //   click: (evt) => {
        //     let dom = utils.closest(evt.target, ".c-content-carousel__item--secondary");
        //     dom && this.showLevelIntro(dom.getAttribute("data-idx"));
        //   }
        // }
      },
      items4Level: [
        {
          text: "银卡", cls: "m-loyalty-program__slide--orchid", level: "等级1/3",
          src: orchid,
          src2x: orchid2x,
          desc: {
            main: "首次入会任意消费即可成为银卡会员",
            options: [
              "购物享积分，可用于兑换独家奢礼",
              "生日礼2000积分（仅限近12个月有消费的会员），生日当月至次月首笔消费获双倍积分，预约免费体验30分钟手部护理",
              "第一时间体验新产品，免费获赠产品体验装",
              "免费体验专业级眼护、面护、彩妆、秀发护理等奢宠服务（限线下指定柜台，需提前预约）"
            ]
          }
        },
        {
          text: "金卡", cls: "m-loyalty-program__slide--gold", level: "等级2/3",
          src: gold,
          src2x: gold2x,
          desc: {
            main: "首次入会，单笔订单（正装商品）消费金额满20000元，即可直接升级成为金卡会员；银卡会员在身份有效期内累计购买正装商品消费金额满20000元，即可升级成为金卡会员。",
            options: [
              "购物享积分，可用于兑换独家奢礼",
              "升级保级礼：额外获赠1000积分",
              "专属生日礼（仅限近12个月有消费的会员），生日当月至次月首笔消费获双倍积分，预约免费体验30分钟手部护理，凭生日祝福短信可享75分钟纯植物香薰护理一次（限当地城市有线下固定美容坊柜台）",
              "第一时间体验新产品，独家尊享优惠套装或买赠礼遇，亲身莅临优雅美颜会",
              "免费体验专业级眼护、面护、彩妆、秀发护理等奢宠服务（限线下指定柜台，需提前预约）"
            ]
          }
        },
        {
          text: "白金卡", cls: "m-loyalty-program__slide--platinum", level: "等级3/3",
          src: platinum,
          src2x: platinum2x,
          desc: {
            main: "首次入会，单笔订单（正装商品）消费金额满40000元，即可直接升级成为白金卡会员；银卡会员在当前身份有效期内累计正装商品消费金额直接满40000元，可升级成为白金卡会员（若身份有效期内累计正装商品消费先满20000元则优先升级为金卡会员，在金卡会员身份有效期内，重新累计正装商品消费满40000元，则可升级为白金卡会员)。",
            options: [
              "购物享积分，可用于兑换独家奢礼",
              "升级保级礼：额外获赠2000积分",
              "专属生日礼（仅限近12个月有消费的会员），生日当月至次月首笔消费获双倍积分，预约免费体验30分钟手部护理，凭生日祝福短信可享105分钟纯植物香薰护理一次（限当地城市有线下固定美容坊柜台）",
              "第一时间体验新产品，独家尊享优惠套装或买赠礼遇，尊享定制奢华美颜会",
              "免费体验专业级眼护、面护、彩妆、秀发护理等奢宠服务（限线下指定柜台，需提前预约）"
            ]
          }
        }
      ],
      vsOpts: {
        bar: { background: '#F6F6F6' }
      },
      showLevelIndex: -1,
      currLevelImage: "",
      items4QA: [
        { q: "我的会员身份有效期怎么算？", a: "银卡/金卡/白金卡会员身份自符合升卡条件次日起12个月，即从身份开始当天至下一年当月最后一天为一个身份有效期。同时，会员身份有效期和积分有效期相互独立，银卡/金卡/白金卡身份将对会员专享权益及兑换比例有所影晌，但不影响积分有效期的计算。" },
        { q: "会员如何升级或保级？", a: "银卡身份有效期内有任意1笔正装商品消费，下一年将自动保级银卡会员，否则身份失效。金卡身份有效期内累计正装商品消费金额满20000元，下一年将自动保级金卡会员身份，否则身份失效，下一年将自动转为银卡会员身份。金卡升保级成功可额外享1000积分。白金卡身份有效期内累计正装商品消费金额满40000元，下一年将自动保级白金卡会员身份；若身份有效期间累计正装商品消费金额介于20000至39999元，下一年将自动转为金卡会员；若身份有效期内累计正装商品消费金额未满20000元，下一年将自动转为银卡会员身份。白金卡保级成功可额外享2000积分。" },
        { q: "我的积分有效期怎么算？", a: "2021年起产生的积分，有效期自该积分订单日期开始计算，每一笔积分有效期为12个月，有效期届满的积分将自动失效，积分失效清零后无法返还。例如：2021年1月16日购买积累3000积分，该笔积分将于2022年1月15日到期。" },
        { q: "法国希思黎中国官方网站、微信小程序官方商城、天猫旗舰店与柜台购物积分可以累积吗？", a: "当使用同一个会员卡号时，法国希思黎中国官方网站、微信小程序官方商城、天猫旗舰店与柜台的购物积分将自动累积。" },
        // { q: "我可以仅使用会员积分兑换产品/权益，而无需在网站上购买其他产品吗？", a: "在法国希思黎官网积分商城中兑换的产品/权益，需要您下单任意其他商品带出。" },
        // { q: "官网积分兑礼的产品/权益有使用期限吗？", a: "通过官网积分兑礼获得的产品/权益，有效期为7天，请您尽快下单使用。" },
        // { q: "含官网积分兑礼商品的订单，我可以退换货吗？", a: "含积分兑礼商品的订单支持退换货，退货后扣除的积分不予返还。" },
      ],
      activeIndex: -1
    }
  },
  mounted() {
    this.$nextTick(() => {
      this.mcSwiper = this.$refs?.['mcSwiper' + this._uid]?.swiper;
    });
  },
  methods: {
    htmlify(str) {
      return str.replace(/\r\n/g, '<br/>').replace(/\n/g, '<br/>');
    },
    showLevelIntro(idx) {
      this.showLevelIndex = idx;
      if (idx == 2) {
        this.currLevelImage = i3;
      } else if (idx == 1) {
        this.currLevelImage = i2;
      } else {
        this.currLevelImage = i1;
      }
    },
    hideLevelIntro() { this.showLevelIndex = -1; },
    toggle(idx) {
      this.activeIndex = this.activeIndex == idx ? -1 : idx;
    }
  }
}
</script>

<style lang="scss" scoped>
.m-loyalty-program {
  padding: 0 1.0625rem;
}

.m-loyalty-program__title {
  margin-top: 1.75rem;
}

.m-loyalty-program__title-logo {
  text-align: center;
}

.m-loyalty-program__title-heading {
  font-size: 2.5rem;
  font-family: HelveticaNeueLTW05-35Thin, arial, sans-serif;
  margin: .9375rem 0;
}

.m-loyalty-program__title-heading .my-sisley-club-logo {
  width: 16.875rem;
}

.m-loyalty-program__title-desc {
  font-size: 18px;
  color: #282828;
  line-height: 25px;
}

.m-loyalty-program__title-description {
  font-size: 13px;
  color: #000;
}

// 消费&积分比例
.m-loyalty-program__subscription {
  position: relative;
  z-index: 1;
  margin-top: 1.875rem;
  border: .0625rem solid #eee;
  background-color: #f9f9f9;
}

.m-loyalty-program__subscription-flower {
  position: absolute;
  right: 1.25rem;
  top: 1.25rem;
  z-index: -1;
}

.m-loyalty-program__subscription-title {
  font-size: 1.5625rem;
  margin: 3.75rem 0 5rem;
  padding-right: 2rem;
}

.m-loyalty-program__subscription-value {
  font-family: HelveticaNeueLTW05-75Bold, arial, sans-serif;
  letter-spacing: -.59375rem;
  line-height: .53;
  font-size: 6.875rem;
}

.m-loyalty-program__subscription-currency {
  font-family: HelveticaNeueLTW05-75Bold, arial, sans-serif;
  line-height: 1.93;
  letter-spacing: -.1625rem;
  font-size: 1.875rem;
}

.m-loyalty-program__subscription-label {
  margin-bottom: 0;
  line-height: 1;
  padding-left: 1.25rem;
}

.m-loyalty-program__subscription-equal-sign {
  font-size: 3.125rem;
  color: #dfdfdf;
  text-align: center;
  line-height: 1;
  letter-spacing: -.8125rem;
  font-family: HelveticaNeueLTW05-35Thin, arial, sans-serif;
  padding-bottom: .9375rem;
}

.m-loyalty-program__subscription-item--platinum {
  text-align: center;

  .m-loyalty-program__subscription-value {
    color: #262626;
  }

  .m-loyalty-program__subscription-currency {
    color: #cacaca;
    margin-left: -.5rem;
  }

  .m-loyalty-program__subscription-label {
    color: #000;
  }
}

.m-loyalty-program__subscription-item--gold {
  text-align: center;

  .m-loyalty-program__subscription-value {
    color: #d3ba71;
  }

  .m-loyalty-program__subscription-currency {
    color: #f0e0a8;
    margin-left: -1.125rem;
  }

  .m-loyalty-program__subscription-label {
    color: #c9a455;
  }
}

// 分割线
.m-loyalty-program__subscription-separator {
  border: none;
  border-bottom: .0625rem solid #dfdfdf;
  margin: 2.1875rem 2.0625rem 1.875rem;
}

// 会员&积分描述文本
.m-loyalty-program__subscription-texts {
  padding: 0 2.0625rem;
}

.m-loyalty-program__subscription-subtitle {
  font-weight: 700;
}

.m-loyalty-program__subscription-description {
  color: #000;
  margin: .625rem 0 2.5rem;
}

.m-loyalty-program__subscription-actions {
  padding: 0 2.0625rem 2.75rem;
}

.m-loyalty-program__subscription-actions .c-button {
  display: none;
}

.m-loyalty-program__subscription-colored-boxes {
  padding: 0 .625rem;
}

.m-loyalty-program__subscription-colored-box {
  height: .3125rem;
}

.m-loyalty-program__subscription-colored-box--orchid {
  background-color: #7c8d7c;
}

.m-loyalty-program__subscription-colored-box--gold {
  background-color: #d3ba71;
}

.m-loyalty-program__subscription-colored-box--platinum {
  background-color: #5c6b70;
}

// 轮播
.m-loyalty-program__slider {
  padding-top: 1.875rem;
  position: relative;
}

.swiper__wrap .swiper-x-container {
  padding-right: 3rem;
  padding-left: 1rem;
}

.c-content-carousel__item--secondary {
  padding: 0 1.0625rem 0 0;
  text-align: center;
}

.c-text-image {
  display: block;
  text-decoration: none;
}

.c-text-image--sixth .c-text-image__visual {
  position: relative;
  padding: 0;
}

.c-text-image--sixth .c-text-image__tag,
.c-text-image--sixth .c-text-image__visual-title {
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
}

.c-text-image--sixth .c-text-image__visual-title {
  display: inline-block;
  white-space: nowrap;
  padding: 0 .625rem;
  color: #fff;
  line-height: 1.5;
  font-family: HelveticaNeueLTW05-75Bold, arial, sans-serif;
  font-size: 2.5rem;
  background-color: #000;
}

.m-loyalty-program__slide--orchid .c-text-image__visual-title {
  background-color: #50704c;
}

.m-loyalty-program__slide--gold .c-text-image__visual-title {
  background-color: #c49946;
}

.m-loyalty-program__slide--platinum .c-text-image__visual-title {
  background-color: #34474e;
}

.c-text-image__tag {
  font-family: HelveticaNeueLTW05-45Light, arial, sans-serif;
  color: #fff;
  padding: .3125rem .625rem;
  display: inline-block;
}

.c-text-image__tag--black {
  background-color: #000;
}

.c-text-image--sixth .c-text-image__tag {
  white-space: nowrap;
  padding: .125rem .5rem;
  font-size: .9375rem;
  margin-top: -2.3125rem;
}

.c-text-image--sixth .c-text-image__content {
  display: flex;
}

.c-text-image--sixth .c-text-image__content .c-text-image__text {
  flex-grow: 1;
  width: 0;
  text-align: left;
}

.c-text-image--sixth .c-text-image__description {
  color: #000;
  margin: .8125rem 0;
  font-size: 1rem;
}

.c-text-image--sixth .c-text-image__list {
  color: #000;
}

.c-text-image--sixth .c-text-image__list-item {
  position: relative;
  padding-left: 1.875rem;
  margin-bottom: .625rem;
}

.c-text-image--sixth .c-text-image__list-item:before {
  content: "";
  width: .9375rem;
  height: .5rem;
  position: absolute;
  left: 0;
  top: .1875rem;
  display: inline-block;
  border: .0625rem solid #000;
  transform: rotate(-50deg);
  border-right: 0;
  border-top: 0;
}

.m-loyalty-program__slide--orchid .c-text-image__list-item:before {
  border-color: #50704c;
}

.m-loyalty-program__slide--gold .c-text-image__list-item:before {
  border-color: #c49946;
}

.m-loyalty-program__slide--platinum .c-text-image__list-item:before {
  border-color: #34474e;
}

.c-text-image__btn {
  display: inline-block;
  vertical-align: middle;
  padding: .8125rem 1.875rem;
  -webkit-appearance: none;
  border-radius: 1.375rem;
  transition: background-color .25s ease-out, color .25s ease-out;
  font-family: HelveticaNeueLTW05-75Bold, arial, sans-serif;
  font-size: .625rem;
  color: #000;
  line-height: 1;
  text-decoration: none;
  text-transform: uppercase;
  letter-spacing: .0625rem;
  text-align: center;
  cursor: pointer;
  background: transparent;
  border: .0625rem solid #cacaca;
}

.m-loyalty-program__slide--orchid .c-text-image__btn {
  border-color: #50704c;
  color: #50704c;
}

.m-loyalty-program__slide--gold .c-text-image__btn {
  border-color: #c49946;
  color: #c49946;
}

.m-loyalty-program__slide--platinum .c-text-image__btn {
  border-color: #34474e;
  color: #34474e;
}

// 问答
.m-loyalty-program__faq-heading {
  position: relative;
  margin: 3.4375rem 0 .625rem;
}

.m-loyalty-program__faq {
  padding: 0 0 4.6875rem;
}

.m-loyalty-program__faq .c-toggler {
  border-bottom: .0625rem solid #dfdfdf;
  padding: 1.25rem 0;
}

.c-toggler__title {
  position: relative;
  cursor: pointer;
  border-top: .0625rem solid #dfdfdf;
  border-bottom: .0625rem solid #dfdfdf;
  padding: .9375rem 0;
  margin-bottom: 0;
  display: block;
}

.m-loyalty-program__faq .c-toggler__title {
  border-top: none;
  border-bottom: none;
  padding: .8125rem 2.5rem .8125rem 0;
}

.c-toggler__title:after {
  content: "";
  background: url(../assets/imgs/icons/arrow-big.svg) no-repeat;
  width: .9375rem;
  height: .5rem;
  right: 0;
  background-size: contain;
  position: absolute;
  top: 50%;
  transform: translateY(-50%) translateY(-.5px);
}

.c-toggler__content {
  display: none;
}

.m-loyalty-program__faq .c-toggler__content {
  padding: 0 2.5rem .8125rem 0;
}

.c-toggler--expanded .c-toggler__title:after {
  transform: translateY(-50%) translateY(-.5px) rotate(180deg);
}

.c-toggler--expanded .c-toggler__content {
  display: inherit;
}

// BG Image
.m-loyalty-program__background {
  position: absolute;
  left: 50%;
  top: 0;
  transform: translateX(-50%);
  width: 100%;
  text-align: center;
}

// 
::v-deep .level-intro {
  .mask {
    z-index: 11;
  }

  .dialog-container {
    width: 470px;
    max-width: 90%;
    min-width: 285px;
    height: 464px;
    transition: all 0.2s ease-in;

    .dialog-body {
      flex-direction: column;
      padding: 0 20px;

      .level__intro--image {
        margin-top: 4rem;
        margin-bottom: 2rem;
        height: 368px;
        overflow: auto;
      }
    }
  }
}

@media screen and (min-width: 48em) {
  .m-loyalty-program {
    padding: 0 3.875rem;
  }

  .m-loyalty-program__title {
    margin-top: 3.4375rem;
  }

  // 消费&积分比例
  .m-loyalty-program__subscription {
    margin-top: 4.375rem;
  }

  .m-loyalty-program__subscription-title {
    margin: 3.75rem 0 7.5rem;
    padding-right: 0;
  }

  .m-loyalty-program__subscription-item--gold {
    text-align: left;
  }

  .m-loyalty-program__subscription-item--platinum {
    text-align: right;
  }

  // 分割线
  .m-loyalty-program__subscription-separator {
    margin: 6.5625rem 1.875rem 4.375rem;
  }

  // 会员&积分描述文本
  .m-loyalty-program__subscription-texts {
    padding: 0 .625rem;
  }

  .m-loyalty-program__subscription-subtitle {
    width: auto;
    max-width: 10.625rem;
  }

  .m-loyalty-program__subscription-description {
    margin: .625rem 0 2.1875rem;
  }

  .m-loyalty-program__subscription-actions {
    padding: 0 2.0625rem 3.125rem;
    text-align: center;
  }

  // .m-loyalty-program__subscription-actions .c-button+.c-button { margin-left: .9375rem; }
  .m-loyalty-program__subscription-colored-boxes {
    width: 24.375rem;
    margin: 0 auto;
  }

  // 轮播
  .m-loyalty-program__slider {
    padding-top: 5rem;
  }

  .swiper__wrap .swiper-x-container {
    padding-right: 10.625rem;
    padding-left: 3.875rem;
  }

  .c-text-image--sixth .c-text-image__visual-title {
    font-size: 3.75rem;
    line-height: 1.2;
  }

  .c-text-image--sixth .c-text-image__tag {
    font-size: 1.25rem;
    margin-top: -2.8125rem;
    padding: 0 .5rem;
  }

  // 问答
  .m-loyalty-program__faq-heading {
    margin: 4.0625rem 0 .625rem;
  }

  .m-loyalty-program__faq {
    padding: 0 0 5.625rem;
  }
}

@media screen and (min-width: 64em) {
  .m-loyalty-program {
    padding: 0 1.875rem;
  }

  .m-loyalty-program__title {
    margin-top: 4.0625rem;
  }

  .m-loyalty-program__title-logo {
    text-align: left;
  }

  .m-loyalty-program__title-heading {
    margin: 12.5rem 0 .9375rem;
  }

  .m-loyalty-program__title-description {
    max-width: 24.375rem;
  }

  // 消费&积分比例
  .m-loyalty-program__subscription-visual {
    padding: 0 3.125rem;
  }

  .m-loyalty-program__subscription-title {
    margin: 3.75rem 0 6.25rem;
    padding-right: 0;
  }

  .m-loyalty-program__subscription-value {
    font-size: 8.75rem;
  }

  .m-loyalty-program__subscription-currency {
    font-size: 2.8125rem;
  }

  .m-loyalty-program__subscription-equal-sign {
    text-align: center;
  }

  // 分割线
  .m-loyalty-program__subscription-separator {
    margin: 5.625rem 6.25rem 4.375rem;
  }

  // 会员&积分描述文本
  .m-loyalty-program__subscription-texts {
    padding: 0 6.25rem;
  }

  // .m-loyalty-program__subscription-subtitle { padding-right: 1.875rem; max-width: 12.5rem; }
  .m-loyalty-program__subscription-subtitle {
    margin-left: 0.9375rem;
    max-width: 12.5rem;
  }

  // .m-loyalty-program__subscription-description { margin: .625rem 1.875rem 3.125rem 0; }
  .m-loyalty-program__subscription-description {
    margin: .625rem 0.9375rem 3.125rem 0.9375rem;
  }

  .m-loyalty-program__subscription-actions {
    padding: 0 2.0625rem 4.6875rem;
  }

  // 问答
  .m-loyalty-program__faq-heading {
    margin: 4.0625rem 0 2.5rem;
  }
}

@media screen and (min-width: 75em) {
  .main-content--spaced {
    padding-top: 11.75rem;
  }

  .m-loyalty-program {
    padding: 0;
  }

  // 消费&积分比例
  .m-loyalty-program__subscription-visual {
    padding: 0 9.375rem;
  }

  // 会员&积分描述文本
  .m-loyalty-program__subscription-texts {
    padding: 0 10.5rem;
  }

  // .m-loyalty-program__subscription-subtitle { padding-right: 4.375rem; max-width: none; }
  .m-loyalty-program__subscription-subtitle {
    margin-left: 2.1875rem;
    max-width: none;
  }

  // .m-loyalty-program__subscription-description { margin: .625rem 4.375rem 3.125rem 0; }
  .m-loyalty-program__subscription-description {
    margin: .625rem 2.1875rem 3.125rem 2.1875rem;
  }

  // 轮播
  .m-loyalty-program__slider {
    padding-top: 6.25rem;
  }

  .swiper__wrap .swiper-x-container {
    padding-right: 0;
    padding-left: 0;
  }

  // 
  .m-loyalty-program__faq {
    padding: 0 12.5rem 6.25rem;
  }
}
</style>